










































import { Component, Prop } from 'vue-property-decorator';
import RouterAndStringMixin from "@/utils/CommonMixin";
import { ImageInfo } from "frontend-common";

@Component export default class extends RouterAndStringMixin {

    @Prop() image!: ImageInfo

    private progress = false

    get imageUrl(): string {
        return this.image?.photo.mq.url ?? ""
    }

    get imageName(): string {
        return this.image?.name ?? ""
    }

    get uploaded(): number {
        return this.image?.created ?? 0
    }

    onDeleteClicked() {
        this.$emit("onImageDelete", this.image)
    }

    goBack() {
        this.$emit("onGoBack", this.image)
    }

    startProgress() {
        this.progress = true
    }

    resetProgress() {
        this.progress = false
    }
}
